import BigNumber from 'bignumber.js'

export const calculateBankDepositAmount = (depositAmount: BigNumber.Value, bonusBalance: BigNumber.Value) =>
  BigNumber.max(new BigNumber(depositAmount).minus(bonusBalance), 0)
